<div *ngIf="loading" class="text-center">
    <p-progressSpinner></p-progressSpinner>
</div>
<form *ngIf="!loading" [formGroup]="form" class="validated-form">
    <lister-configuration [listerPages]="allTiles | async" [productName]="productName" formControlName="listerConfiguration"></lister-configuration>
</form>